import type { Node } from './../../../../../ricos-schema/legacy/wix/rich_content/v1';
import { MAX_LIST_VISIBLE_INDENTATION, normalizeOffset } from './../../../../../wix-rich-content-common';

export function getStartMargin(parentNode: Node | null, visibleIndentation: number) {
  if (!parentNode) {
    return '1.5em';
  }

  const parenNodeDataName = `${parentNode?.type?.slice(0, -5).toLowerCase()}ListData`;
  const nodeOffset: number =
    (parentNode[parenNodeDataName as $TSFixMeKey<typeof parentNode>] as $TSFixMe)?.offset || 0;
  const offset =
    visibleIndentation > MAX_LIST_VISIBLE_INDENTATION
      ? nodeOffset - (visibleIndentation - MAX_LIST_VISIBLE_INDENTATION)
      : normalizeOffset(nodeOffset);

  return parentNode ? `${normalizeOffset(offset) * 2 + 1.5}em` : '';
}
